export default __webpack_public_path__ + "static/media/army_93.d0855c99.jpg";